@if (spinnerService.isLoading()) {
  <div class="spinner-overlay">
    <div class="loader-card">
      <div class="logo-wrapper">
        <span class="fw-bold">A2 Hacienda</span>

        <div class="tron-path"></div>
      </div>

      <div class="loader-info">
        <h6 class="loading-text">{{ spinnerService.message() }}</h6>
        <div class="progress-container">
          <div class="progress-bar-fill"></div>
        </div>
      </div>
    </div>
  </div>
}
